import React from 'react';
import createModal from 'modules/modal';
import DefaultLayout from 'modules/modal/layouts';
import HeadlineHeader from 'modules/modal/components/headlineHeader';
import { toHtmlContent } from 'modules/helpers/strings';
import { SvgSprite } from './svgSprite';

export default class SecondaryMenu {
    constructor(menu) {
        this.body = $('body');

        this.mainView = this.body.find('.js-view-main');
        this.secondaryMenu = menu;
        this.secondaryMenuDropDown = this.secondaryMenu.find('.js-secondaryMenuDropdown');

        if (this.secondaryMenu.length) {
            this.mainView.addClass('view--has-secondary-menu');
        }

        this.openSecondaryMenu = this.openSecondaryMenu.bind(this);
    }

    init() {
        if (this.secondaryMenu.length) {
            this.secondaryMenuDropDown.on('click', this.openSecondaryMenu);
        }
    }

    openSecondaryMenu() {
        const list = this.secondaryMenu.find('.js-secondaryMenuList');

        const headline = this.secondaryMenuDropDown.data('menu-headline');
        const headlineSprite = this.secondaryMenuDropDown.data('menu-headline-sprite');
        let sprite;

        if (headlineSprite) {
            sprite = <SvgSprite sprite={headlineSprite} />;
        }

        const modal = createModal({
            layout: {
                component: <DefaultLayout className="secondarymenu-modal" />,
                header: <HeadlineHeader headline={headline || sprite} />
            }
        });
        modal({ open: true, content: toHtmlContent(list[0].outerHTML) });
    }
}
